module.exports = __webpack_public_path__ + "img/incentive_paid.5796532b.png";